import { Injectable } from '@angular/core';
import type { RateQuote } from './types';

@Injectable({ providedIn: 'root' })
export class RatesStore {
  private selectedQuote?: RateQuote;

  selectQuote(quote: RateQuote) {
    this.selectedQuote = quote;
  }

  getSelectedQuote() {
    return this.selectedQuote;
  }
}